import { render, staticRenderFns } from "./GroupMemberManagement.vue?vue&type=template&id=b8fda3ee&"
import script from "./GroupMemberManagement.vue?vue&type=script&lang=js&"
export * from "./GroupMemberManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports